<template>
  <div 
    class="modal fade"
    id="checkImportModal"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>CHECK IMPORT</b>
          </h4>
        </div>
        <div class="modal-body">
          <!-- FIRST WINDOW -->
          <div v-if="!importDataChecked">
            <p>Enter the SurveyID and select your import file. Then click on 'Check Data'. The file will be checked and potential problems will be shown.</p>
            <form v-on:submit.prevent="getSurveyDataAndCheckImportData()">
              <input 
                type="number" 
                name="sid" 
                id="sidInput" 
                placeholder="SID"
                v-model="sid"
                required
              />
              <input
                id="checkImportFileInput"
                class="form-control nopadding"
                type="file"
                accept=".xlsx"
                @change="onImportFileChange"
                required
              />
              <button
                type="button"
                class="btn btn-raised btn-default"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-raised dialog-btn-primary">Check Data</button>
            </form>
          </div>
          <!-- SECOND WINDOW -->
          <div v-if="importDataChecked && !importFinished">
            <p v-if="!showUndefinedElements && invalidChecks.length == 0 && !showUndefinedQuestionChoices">No Problems found! Proceed with import by clicking 'Import'</p>
            <p v-if="showUndefinedElements || invalidChecks.length != 0 || showUndefinedQuestionChoices">The following problems have been identified:</p>
            <div class="accordion">
              <!-- Invalid Checks -->
              <div class="accordionElement" v-if="invalidChecks.length != 0">
                <button class="accordionBtn" v-b-toggle="`accordionInvalidChecks`" @click="turnAround('iconInvalidChecks')">
                  <span><span class="accordionElementTitle">Invalid Checks</span> ({{invalidChecks.length}})</span>
                  <i class="material-icons" id="iconInvalidChecks">
                    expand_more
                  </i>
                </button>
                <b-collapse class="accordionContent" id="accordionInvalidChecks">
                  <div v-for="check in invalidChecks" :key="check.checkId">
                    <p>Row: {{check.row}}, CheckID: {{check.checkId}}, Message: {{check.msg}}</p>
                  </div>
                </b-collapse>
              </div>
              <!-- Undefined Elements -->
              <div class="accordionElement" v-if="showUndefinedElements">
                <button class="accordionBtn" v-b-toggle="`accordionUndefinedElements`" @click="turnAround('iconUndefinedElements')">
                  <span><span class="accordionElementTitle">Undefined Elements</span> ({{undefinedElements.length}})</span>
                  <i class="material-icons" id="iconUndefinedElements">
                    expand_more
                  </i>
                </button>
                <b-collapse class="accordionContent" id="accordionUndefinedElements">
                  <div v-for="e in undefinedElements" :key="e.guid">
                    <p>Column: {{e.column}}, GUID: {{e.guid}}</p>
                  </div>
                </b-collapse>
              </div>
              <!-- Undefined Question Choices -->
              <div class="accordionElement" v-if="showUndefinedQuestionChoices">
                <button class="accordionBtn" v-b-toggle="`accordionUndefinedQuestionChoices`" @click="turnAround('iconUndefinedQuestionChoices')">
                  <span><span class="accordionElementTitle">Undefined Question Choices</span> ({{undefinedQuestionChoices.length}})</span>
                  <i class="material-icons" id="iconUndefinedQuestionChoices">
                    expand_more
                  </i>
                </button>
                <b-collapse class="accordionContent" id="accordionUndefinedQuestionChoices">
                  <div v-for="(e, index) in undefinedQuestionChoices" :key="index">
                    <p>Row: {{e.row}}, Column: {{e.column}}, CheckID: {{e.check}}, GUID: {{e.guid}}</p>
                  </div>
                </b-collapse>
              </div>
            </div>
            <p v-if="showUndefinedElements || invalidChecks.length != 0 || showUndefinedQuestionChoices">Do you want to proceed? Problematic elements will be skipped.</p>
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="saveSurveys()"
              :disabled="!enableUpload()"
            >
              Import
            </button>
          </div>
          <!-- THIRD WINDOW -->
          <div v-if="importFinished">
            <p>The import was finished.</p>
            <p>Start: {{importStart}}</p>
            <p>End: {{importEnd}}</p>
            <p>{{failedRequests.length}} check imports failed.</p>
            <div class="accordion">
              <!-- Failed Requests -->
              <div class="accordionElement" v-if="showFailedRequests">
                <button class="accordionBtn" v-b-toggle="`accordionFailedRequests`" @click="turnAround('iconFailedRequests')" >
                  <span class="accordionElementTitle">Failed Requests</span>
                  <i class="material-icons" id="iconFailedRequests">
                    expand_more
                  </i>
                </button>
                <b-collapse class="accordionContent" id="accordionFailedRequests">
                  <div v-for="(e, index) in failedRequests" :key="index">
                    <p>CheckID: {{e.check}}, Time: {{e.time}}</p>
                  </div>
                </b-collapse>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "CheckImportModal",
  data() {
    return {
      sid: null,
      SurveyInstances: [],
      SurveyQuestions: {},
      SurveyQuestionChoices: {},
      selectedFile: {},
      header: [],
      importData: [],
      undefinedElements: [],
      showUndefinedElements: false,
      requests: [],
      failedRequests: [],
      showFailedRequests: false,
      gotSurveyData: false,
      importDataChecked: false,
      uploadDisabled: true,
      undefinedQuestionChoices: [],
      showUndefinedQuestionChoices: false,
      invalidChecks: [],
      importFinished: false,
      importStart: null,
      importEnd: null
    }
  },
  methods: {
    openModal() {
      this.selectedFile = {},
      $("#checkImportModal").modal("show");
    },
    closeModal() {
      $("#checkImportModal").modal("hide");
    },
    onImportFileChange(e) {
      this.selectedFile = e.target.files[0];

      const reader = new FileReader();
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        this.importData = XLSX.utils.sheet_to_json(ws, { header: 1 , defval:""});
        this.header = this.importData.shift();
      };
      reader.readAsBinaryString(this.selectedFile);
    },
    checkImportData() {
      this.formatHeaders();
      this.setUpSurveyInstanceAnswers();
      if(this.undefinedElements.length != 0) {
        this.globals.showErrorSnackbar(this.undefinedElements.length + " undefined element(s)");
      } 
      this.importDataChecked = true;
    },
    setUpSurveyInstanceAnswers() {
      var request;
      var SurveyInstanceAnswer;
      var currentRowNumber = 1;

      this.requests = [];

      this.importData.forEach(row => {
        currentRowNumber++;
        request = {
          checkId: null,
          content: {
            LocaleCode: "en-GB",
            SurveyInstanceAnswer: null,
            SurveyInstanceAnswerDateOfVisit: null,
            SurveyInstanceAnswerMaxPoints: 0,
            SurveyInstanceAnswerMemoAgency: "",
            SurveyInstanceAnswerMemoMSM: "",
            SurveyInstanceAnswerMemoShopper: "",
            SurveyInstanceAnswerPoints: 0,
            SurveyInstanceAnswerTimeIn: null,
            SurveyInstanceAnswerTimeOut: null,
            SurveyInstanceProgress: 100
          }
        };
        SurveyInstanceAnswer = {};

        for (const key in row) {
          var guid;

          // Guids of questions, comments and translations have a length of 37, because a Q, C or T was added. That Letter has to be removed to find the question per guid.
          // Multiple Choice (MC) answers have a length of 36
          if(this.header[key].length === 37) {
            // get questions
            guid = this.header[key].substring(1, 37);

            if (this.header[key].substring(0, 1) === "T") {
              // catch translations
              // "t_" identifies translations in the save request
              var t_name = "t_";
              var l = this.SurveyQuestions.find(q => q.QuestionGuid == guid );
              if (l != undefined) {
                t_name = t_name + l.Name;
                SurveyInstanceAnswer[t_name] = row[key];
              } else {
                this.addToUndefinedElements(guid, key);
              }
            } else if (this.header[key].substring(0, 1) === "C") {
              var l = this.SurveyQuestions.find(q => q.QuestionGuid == guid );
              if (l != undefined) {
                if (l.Type === "text" || l.Type === "comment") {
                  if (row[key] != "") {
                    SurveyInstanceAnswer[l.Name] = row[key];
                  }
                } else if (l.HasComment === true) {
                  var newGuid = l.CommentGuid;
                  var m = this.SurveyQuestions.find(q => q.QuestionGuid == newGuid );
                  if (row[key] != "") {
                    SurveyInstanceAnswer[m.Name] = row[key];
                  }
                }
              } else {
                this.addToUndefinedElements(guid, key);
              }
            } else {
              var l = this.SurveyQuestions.find(q => q.QuestionGuid == guid );
              if (l != undefined) {
                if (l.Type === "checkbox") {
                  // MC answers will be stored in an array
                  SurveyInstanceAnswer[l.Name] = [];
                } else if (l.Type === "radiogroup" || l.Type === "dropdown") {
                  if(row[key] != "") {
                    var answer = this.SurveyQuestionChoices.find(qc => qc.QuestionGuid == guid && qc.Position == row[key]);
                    if(answer != undefined) {
                      SurveyInstanceAnswer[l.Name] = answer.Name;
                    } else {
                      this.showUndefinedQuestionChoices = true;
                      this.undefinedQuestionChoices.push({column: this.columnToLetter(parseInt(key) + 1), row: currentRowNumber, check: request.checkId, guid: guid})
                    }
                  } else {
                    SurveyInstanceAnswer[l.Name] = "";
                  }
                } else {
                  SurveyInstanceAnswer[l.Name] = row[key];
                }
              } else {
                this.addToUndefinedElements(guid, key);
              }
            }
          } else if (this.header[key].length === 36 && row[key] != "") {
            // mc answer
            guid = this.header[key];
            var answer = this.SurveyQuestionChoices.find(qc => qc.ChoiceGuid == guid );
            if (answer != undefined) {
              var question = this.SurveyQuestions.find(q => q.QuestionGuid == answer.QuestionGuid);
              if (question != undefined) {
                // SurveyInstanceAnswer[question.Name] is undefined when the MC Question was not found (wrong GUID in import file)
                // when undefined skip question choices of that question
                if (SurveyInstanceAnswer[question.Name] != undefined) {
                  SurveyInstanceAnswer[question.Name].push(answer.Name);
                }
              } else {
                this.addToUndefinedElements(guid, key);
              }
            } else {
              this.addToUndefinedElements(guid, key);
            }
          } else if (this.header[key] == "CheckID") {
            request.checkId = row[key];
          } else if (this.header[key] == "Head Date") {
            request.content.SurveyInstanceAnswerDateOfVisit = row[key];
          } else if (this.header[key] == "Head Time") {
            request.content.SurveyInstanceAnswerTimeIn = row[key];
          } else if (this.header[key] == "Head Out Time") {
            request.content.SurveyInstanceAnswerTimeOut = row[key];
          } else if (this.header[key] == "Wave") {
            request.wave = row[key];
          } else if (this.header[key] == "Scenario") {
            request.scenario = row[key];
          } else if (this.header[key] == "Location ID") {
            request.locationId = row[key];
          }
        }
        // finished SurveyInstanceAnswer including empty values
        request.content.SurveyInstanceAnswer = SurveyInstanceAnswer;
        let valid = this.validateRequest(request, currentRowNumber);
        if(request.checkId !== null && valid) {
          this.requests.push(request);
        }
      });
    },
    validateRequest(request, rowNumber) {
      let instance = this.SurveyInstances.find(i => i.SurveyInstanceId == request.checkId);
      if(instance != undefined && instance.SurveyInstanceStatusId == 100 && instance.LocationStoreId == request.locationId && instance.ScenarioName == request.scenario && instance.WaveName == request.wave) {
        return true;
      } else if (instance == undefined){
        this.invalidChecks.push({row: rowNumber, checkId: request.checkId, msg: "CheckID not found in survey."});
      } else if (instance.SurveyInstanceStatusId > 100){
        this.invalidChecks.push({row: rowNumber, checkId: request.checkId, msg: "Checkstatus greater than 100."});
      } else if (instance.LocationStoreId != request.locationId) {
        this.invalidChecks.push({row: rowNumber, checkId: request.checkId, msg: "LocationID does not match."});
      } else if (instance.ScenarioName != request.scenario) {
        this.invalidChecks.push({row: rowNumber, checkId: request.checkId, msg: "Scenario does not match."});
      } else if (instance.WaveName != request.wave) {
        this.invalidChecks.push({row: rowNumber, checkId: request.checkId, msg: "Wave does not match."});
      } else {
        this.invalidChecks.push({row: rowNumber, checkId: request.checkId, msg: ""});
      }
      return false;
    },
    formatHeaders() {
      for (const key in this.header) {
        var index_one = this.header[key].indexOf("[");
        var index_two = this.header[key].indexOf("]");
        var guid = this.header[key].substring(index_one + 1, index_two).toUpperCase();
        if(guid != "") {
          this.header[key] = guid;
        }
      }
    }, 
    addToUndefinedElements(guid, key) {
      var alreadyIn = this.undefinedElements.find(e => e.guid == guid);
      if (alreadyIn == undefined) {
        this.undefinedElements.push({column: this.columnToLetter(parseInt(key) + 1), guid: guid});
        this.showUndefinedElements = true;
      }
    },
    columnToLetter(column) {
      var temp, letter = '';
      while (column > 0) {
        temp = (column - 1) % 26;
        letter = String.fromCharCode(temp + 65) + letter;
        column = (column - temp - 1) / 26;
      }
      return letter;
    },
    async saveSurveys() {
      var date = new Date(Date.now());
      this.importStart = date.toLocaleString();

      this.failedRequests = [];

      for (var key in this.requests) {
        try {
          let requestData = this.requests[key];
          const res = await this.saveSurveyInstance(requestData, key);
          if (res) {
            await this.updateCheckStatus(120, requestData.checkId);
          }
        } catch (err) {
          console.error("Error in saveSurveys");
          console.error(err);
          this.globals.showErrorSnackbar("saving survey instance " + (parseInt(index) + 1) + " failed");
        }
      }
      if(this.failedRequests.length !== 0) {
        this.showFailedRequests = true;
        this.globals.showErrorSnackbar(`${this.failedRequests.length} Check imports failed`);
      } else {
        this.globals.showSuccessSnackbar("Check import complete");
      }
      this.importFinished = true;
      date = new Date(Date.now());
      this.importEnd = date.toLocaleString();
    },
    saveSurveyInstance(requestData, index) {
      return new Promise((resolve, reject) => {
        var date = new Date(Date.now());
        let queryString = `api/SurveyInstancesAnswers/ViaCheckimport/${requestData.checkId}`;
        let data = JSON.stringify(requestData.content, (key, value) => {
          if (value !== null && value !== "" && value.length !== 0) return value
        });
        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (this.isEmpty(data) === false) {
              date = new Date(Date.now());
              console.error(`Problem on PUT in saveSurveys with CheckID: ${requestData.checkId}`);
              this.failedRequests.push({check: requestData.checkId, time: date.toTimeString().substring(0, 8)});
              resolve(false);
            } else {
              resolve(true);
            }
          },
          error: () => {
            date = new Date(Date.now());
            console.error(`Error on PUT in saveSurveys with CheckID: ${requestData.checkId}`);
            this.failedRequests.push({check: requestData.checkId, time: date.toTimeString().substring(0, 8)});
            reject();
          },
          complete: () => {
            this.globals.showSuccessSnackbar((parseInt(index) + 1) + "/" + this.requests.length + " complete");
          }
        });
      })
    },
    async getSurveyData() {
      this.SurveyQuestions = {};
      this.SurveyQuestionChoices = {};
      try {
        await Promise.all([this.getSurveyQuestions(), this.getSurveyQuestionChoices(), this.getSurveyInstances()]);
        if(this.isEmpty(this.SurveyQuestions) === true || this.isEmpty(this.SurveyQuestionChoices) === true || this.SurveyInstances.length === 0) {
          this.globals.showErrorSnackbar("Survey not found");
          this.gotSurveyData = false;
          return false;
        }
        this.gotSurveyData = true;
        return true;
      } catch (err) {
        console.error("Error in getSurveyData");
        console.error(err);
        this.globals.showErrorSnackbar("Survey request failed");
        this.gotSurveyData = false;
        return false;
      }
    },
    async getSurveyDataAndCheckImportData() {
      const succ = await this.getSurveyData();
      if(succ) {
        this.checkImportData();
      };
    },
    isEmpty(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    getSurveyQuestions() {
      return new Promise ((resolve, reject) => {
        let queryString = "api/Surveys/SurveyQuestions/" + this.sid;
        $.ajax({
          url: queryString,
          type: "GET",
          success: (data) => {
            this.SurveyQuestions = data;
            resolve();
          },
          error: () => {
            console.error("Error on GET in getSurveyQuestions"); 
            this.globals.showErrorSnackbar("Request failed");
            reject();
          },
        });
      })
    },
    getSurveyQuestionChoices() {
      return new Promise ((resolve, reject) => {
        let queryString = "api/Surveys/SurveyQuestionChoices/" + this.sid;
        $.ajax({
          url: queryString,
          type: "GET",
          success: (data) => {
            this.SurveyQuestionChoices = data;
            resolve();
          },
          error: () => {
            console.error("Error on GET in getSurveyQuestionChoices");
            this.globals.showErrorSnackbar("Request failed");
            reject();
          },
        });
      })
    },
    updateCheckStatus(status, surveyInstanceId) {
      return new Promise ((resolve, reject) => {
        let sendData = {};
        sendData.SurveyInstanceIds = [surveyInstanceId];
        sendData.SurveyInstanceStatusId = status;
        $.ajax({
          method: "PUT",
          url: "api/SurveyInstances",
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            //if (data.Error) this.globals.showErrorSnackbar(data.Error);
            resolve();
          },
          error: () => {
            console.error("Error on PUT in updateCheckStatus()");
            this.globals.showErrorSnackbar("Status update failed");
            reject();
          },
        });
      })
      
    },
    getSurveyInstances() {
      return new Promise ((resolve, reject) => {
        let queryString = `api/SurveyInstances/Get?sort_column=SurveyInstanceId&sort_order=asc`;
        let body = {"Filter":{"SurveyId":this.sid}};
        $.ajax({
          method: "POST",
          url: queryString,
          data: JSON.stringify(body),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            this.SurveyInstances = data[0].SurveyInstances;
            resolve();
          },
          error: () => {
            console.error("Error on POST in getSurveyInstances");
            this.globals.showErrorSnackbar("Request failed");
            reject();
          },
        });
      })
    },
    enableUpload() {
      if (this.gotSurveyData && this.importDataChecked) {
        return true;
      } else {
        return false;
      }
    },
    turnAround(id) {
      // turns around arrows in the accordion
      document.getElementById(id).classList.toggle("turned180");
    }
  },
  mounted() {
    this.openModal();
    $("#checkImportModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });
  },
}
</script>

<style scoped>
.accordion {
  border: 1px solid  var(--color-secondary-input);
  border-radius: 0.25rem;
  margin: 1%;
  text-align: left;
  display: flex;
  flex-direction: column;
}
.accordionElement {
  width: 100%;
  padding: 0.25rem;
}
.accordionElementTitle {
  font-weight: 700;
}
.accordionBtn {
  min-width: 100%;
  border: none;
  border-radius: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.accordionContent {
  padding-left: 5px;
}
.turned180 {
  transform: rotate(180deg)
}
</style>


// WEBPACK FOOTER //
// CheckImportModal.vue?491bef20